import { render } from "./UserObjectDisplay.vue?vue&type=template&id=191ad8fb&scoped=true&ts=true"
import script from "./UserObjectDisplay.vue?vue&type=script&lang=ts"
export * from "./UserObjectDisplay.vue?vue&type=script&lang=ts"

import "./UserObjectDisplay.vue?vue&type=style&index=0&id=191ad8fb&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191ad8fb"]])

export default __exports__